// base64 名称
export const STORAGE_BASE64 = 'STORAGE_BASE64';

// file 名称
export const STORAGE_FILE = 'STORAGE_FILE';

// SVG 编辑选项类型
export enum SVG_EDITOR_TYPE {
    Transparency = 'Transparency',
    Blend = 'Blend',
    Channel = 'Channel',
    Interpolation = 'Interpolation',
}

// SVG 转 Image 时的类型
export enum SVG_TYPE {
    blob = 'blob',
    base64 = 'base64',
}
